export default {"src":"/_next/static/media/toko_top_up_icon.fba5ca0e.svg","height":123,"width":158};